import { Box, Typography } from "@mui/material"; // Import Box for using the sx prop on plain elements
// No need to explicitly import '@emotion/react' or '@emotion/styled' if you're just using MUI's sx prop
import SkillBadge, {IconPaths} from "./SkillBadge";


export default function MySkills() {
    let skills = [
        "java","python","pytorch","opencv","numpy","matplotlib","golang","adobe","agile",
        "aws","distcomp","django","docker","git","github","githubwork","html","jest",
        "js","kotlin","linux","maven","mspp","mysql","parallelcomp","reactjs","springboot",
        "teaching","vuejs","windows", "c"]

    skills = [...skills].sort((a, b) => IconPaths[a].name.localeCompare(IconPaths[b].name));
    const skillBadges = skills.map((sk) => (<SkillBadge key={sk} skill={sk}/>));
    return (
    <Box item sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            my:4
        }}
        >
            <Typography variant='h3' sx={{fontWeight:800}}>My skills</Typography>
            {skillBadges.length > 0 && (<Box sx={{ px: 2, pb: 2 }}>{skillBadges}</Box>)}
    </Box>
  );
}
